export default __webpack_public_path__ + "static/media/watermark.f3942a90.png";